import { BadgeContainer as KendoBadgeContainer } from '@progress/kendo-react-indicators';

/**
 * This component is a wrapper around the Kendo UI BadgeContainer component.
 * It allows for customization of the badge's appearance and behavior.
 * 
 * @component
 * @param {Object} props - properties passed to the component. 
 * @param {string} props.type - The type of the badge (e.g., 'default', 'success', 'error').
 * @param {string} props.size - The size of the badge (e.g., 'small', 'medium', 'large').
 * @param {string} props.shape - The shape of the badge (e.g., 'rectangle', 'rounded').
 * @param {string} props.themeColor - The theme color of the badge (e.g., 'primary', 'secondary').
 * @param {string} props.className - Additional CSS classes to apply to the badge.
 * @param {ReactNode} props.children - The content to be displayed inside the badge.
 * @returns {JSX.Element}
 * @description: This component is used to create badges with various styles and functionalities.
 * Documentation: https://www.telerik.com/kendo-react-ui/components/indicators/badge/
 */
export const BadgeContainer = ({
  type = 'default',
  size = 'medium',
  shape = 'rectangle',
  themeColor = 'primary',
  children,
  className,
}) => {
  return (
    <KendoBadgeContainer
      type={type}
      size={size}
      shape={shape}
      themeColor={themeColor}
      className={className}
    >
      {children}
    </KendoBadgeContainer>
  );
}